import React, { createContext, useState } from 'react';
import { NativeBaseProvider, extendTheme } from 'native-base';
import designTokens from '../style/design-tokens.json';
import { ADCLoadingSpinner, ADCLoadingSpinnerContext } from './ADCLoadingSpinner';
const themes = designTokens.record.values;
// override/add responsive width breakpoints
const breakpoints = {
    sm: 340,
};
// override/add components styling options
const components = {
    AlertDialog: {
        sizes: {
            custom: {
                contentSize: {
                    width: '100%',
                    maxWidth: '340',
                },
            },
        },
        defaultProps: {
            size: 'custom',
        },
    },
};
// re-create themes with mods
const themesEnhanced = Object.entries(themes).reduce((acc, [name, theme]) => {
    acc[name] = { ...theme, components, breakpoints };
    return acc;
}, {});
export const ADCThemeContext = createContext(themes.polarisLight);
export function ThemeProvider({ children, app = 'polarisLight', extraOptions = {}, colorModeManager, config, disableContrastText, initialWindowMetrics, isSSR, }) {
    const [isLoadingSpinnerOpen, setIsLoadingSpinnerOpen] = useState(false);
    const openLoadingSpinner = () => {
        setIsLoadingSpinnerOpen(true);
    };
    const closeLoadingSpinner = () => {
        setIsLoadingSpinnerOpen(false);
    };
    return (React.createElement(ADCThemeContext.Provider, { value: themes[app] },
        React.createElement(NativeBaseProvider, { theme: extendTheme(themesEnhanced[app], extraOptions), colorModeManager: colorModeManager, config: config, disableContrastText: disableContrastText, initialWindowMetrics: initialWindowMetrics, isSSR: isSSR },
            React.createElement(ADCLoadingSpinnerContext.Provider, { value: {
                    open: openLoadingSpinner,
                    close: closeLoadingSpinner,
                } },
                children,
                React.createElement(ADCLoadingSpinner, { isOpen: isLoadingSpinnerOpen })))));
}
